import { HSOverlay } from "preline";
import { useEffect } from "react";
import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    isVisible: false,
    content: null,
    actionType: "delete",
    onConfirm: null,
  });

  const showModal = (content, actionType = "delete", onConfirm = null) => {
    // const modalOverlay = window
    //   .HSOverlay()
    //   .getInstance("hs-slide-up-animation-modal");

    console.log(content, actionType, onConfirm);
    setModal({ isVisible: true, content, actionType, onConfirm });
  };

  const hideModal = () => {
    setModal({
      isVisible: false,
      content: null,
      actionType: "delete",
      onConfirm: null,
    });
  };

  const handleConfirm = () => {
    if (typeof modal.onConfirm === "function") modal.onConfirm();
    hideModal();
  };

  return (
    <ModalContext.Provider
      value={{ modal, setModal, showModal, hideModal, handleConfirm }}
    >
      {children}
    </ModalContext.Provider>
  );
};
